/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { sendErrorMessage } from '@insticator/insticator-ui'; // iui-state
// component
import AdsTxtIndicator from 'pages/dashboard/account/adstxt/adstxtindicator/adstxtindicator';



/* ========== ~~~~~~~~~~ ADsTXT INDICATOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = () => ({
});

// map actions
const mapDispatchToProps = dispatch => ({
    sendErrorMessage: text => dispatch(sendErrorMessage(text))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdsTxtIndicator);
